import type { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

/** Chest tiers presented for the ordered Dream Drift reward milestones. */
export const dreamDriftMilestoneChestTypes = [
  'wood',
  'silver',
  'gold',
] as const;

/** Chest skin used to present a Dream Drift milestone reward. */
export type DreamDriftChest = (typeof dreamDriftMilestoneChestTypes)[number];

/** Settled reward data retained until the reopened Dream Drift map is visible. */
export type DreamDriftRewardPresentation = {
  /** Chest skin associated with the completed reward settlement. */
  chestType: DreamDriftChest;
  /** Accumulated rewards granted by the completed Dream Drift instance. */
  rewards: Match2Reward[];
};

/** Optional presentations played while the Dream Drift map opens. */
export type DreamDriftMapOpenOptions = {
  /** Chest to present after the map claims pending rewards. */
  rewardChestType?: DreamDriftChest;
};
